import React, { useState } from "react";
import axios from "axios";
import { CgClose } from "react-icons/cg";
import { api } from "../../../../../../../../../api";
import { motion, AnimatePresence } from "framer-motion";

const InterviewScheduler = ({show, applicationId, onClose }) => {
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [message, setMessage] = useState("Bonjour, nous souhaitons vous inviter à un entretien.");
  const [sendEmail, setSendEmail] = useState(true);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [warning, setWarning] = useState("");

  // API pour mettre à jour l'entretien
  const updateInterview = async () => {
    if (!date || !time) {
      setWarning("Veuillez sélectionner une date et une heure.");
      return;
    }
    
    try {
      await axios.post(`${api}/applications/${applicationId}/interview`, {
        interviewed_on: `${date} ${time}`,
        message,
        sendEmail,
      });

      alert("Entretien programmé avec succès !");
      onClose();
    } catch (error) {
      console.error("Erreur lors de la mise à jour :", error);
      setWarning("Une erreur est survenue. Veuillez réessayer.");
    }
  };

  return (

     <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed z-40 bg-gray-900/10 top-0 bottom-0 left-0 right-0 flex justify-end backdrop-blur-sm"
        >
          <motion.div
            initial={{ opacity: 0, right: "-100%", y: 20 }}
            animate={{ opacity: 1, right: 0, y: 0 }}
            exit={{ opacity: 0, right: "-100%", y: 20 }}
            transition={{ type: "spring", stiffness: 130, damping: 20 }}
            className="fixed overflow-y-auto bg-white w-full lg:w-2/3 xl:w-1/2 min-h-full lg:rounded-s-2xl drop-shadow-lg"
          >
      {/* Header */}
      <div className="flex justify-between py-4 border-b px-6">
        <h4 className="text-lg font-bold">Planifier un entretien</h4>
        <button onClick={onClose}>
          <CgClose />
        </button>
      </div>

      {/* Formulaire */}
      <div className="px-6 space-y-4 mt-4">
        {warning && <p className="text-red-500">{warning}</p>}
        
        <label className="block text-gray-700">Date :</label>
        <input
          type="date"
          className="border rounded-md p-2 w-full"
          value={date}
          onChange={(e) => setDate(e.target.value)}
        />

        <label className="block text-gray-700">Heure :</label>
        <input
          type="time"
          className="border rounded-md p-2 w-full"
          value={time}
          onChange={(e) => setTime(e.target.value)}
        />

        <label className="block text-gray-700">Message :</label>
        <textarea
          className="h-32 border rounded-md w-full p-2 bg-gray-50 focus:outline-none"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />

        {/* Option pour envoyer un email */}
        <div className="flex items-center space-x-2">
          <input
            type="checkbox"
            checked={sendEmail}
            onChange={() => setSendEmail(!sendEmail)}
          />
          <label className="text-gray-700">Envoyer un email au candidat</label>
        </div>

        {/* Boutons */}
        <div className="flex justify-end space-x-4">
          <button
            onClick={onClose}
            className="text-primary-black bg-slate-50 rounded-md px-4 py-2 shadow-sm hover:bg-slate-100"
          >
            Annuler
          </button>
          <button
            onClick={() => setShowConfirmModal(true)}
            className="text-white bg-blue-500 rounded-md px-4 py-2 shadow-sm hover:opacity-80"
          >
            Programmer et envoyer
          </button>
        </div>
      </div>

      {/* Modal de confirmation */}
      {showConfirmModal && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex justify-center items-center">
          <div className="bg-white p-6 rounded-lg shadow-lg w-[400px]">
            <h3 className="text-lg font-bold">Confirmer l’entretien</h3>
            <p className="mt-2">Voulez-vous vraiment programmer cet entretien ?</p>
            <div className="flex justify-end space-x-4 mt-4">
              <button
                onClick={() => setShowConfirmModal(false)}
                className="text-gray-700 bg-gray-200 px-4 py-2 rounded-md"
              >
                Annuler
              </button>
              <button
                onClick={updateInterview}
                className="text-white bg-blue-500 px-4 py-2 rounded-md"
              >
                Confirmer
              </button>
            </div>
          </div>
        </div>
      )}
   </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
  );
};

export default InterviewScheduler;
